import { render } from "./TransparentLogos.vue?vue&type=template&id=3556d70c&scoped=true&ts=true"
import script from "./TransparentLogos.vue?vue&type=script&lang=ts"
export * from "./TransparentLogos.vue?vue&type=script&lang=ts"

import "./TransparentLogos.vue?vue&type=style&index=0&id=3556d70c&scoped=true&lang=css"

import exportComponent from "/home/apps/bugaplus/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3556d70c"]])

export default __exports__